<template>
  <div id="home" :style="{ 'margin-bottom': isShowM2 ? '250px' : '50px' }">
    <!-- 目錄 -->
    <headerTitle></headerTitle>

    <!-- /.目錄 -->
    <!-- 社交平台按鈕 -->
    <Social></Social>
    <!-- /.社交平台按鈕 -->
    <!-- <router-view></router-view> -->
    <router-view :key="$route.fullPath.replace('#top', '')"></router-view>
    <!-- <router-view></router-view> -->
    <!-- Footer -->
    <foot></foot>
    <div class="backtop-btn" id="backtop-btn">
      <a href="javascript:void(0)">
        <div class="backtop-icon fas fa-angle-up"></div>
      </a>
    </div>
    <!-- <div class="line-it-button" data-lang="zh_Hant" data-type="share-a" data-env="REAL" data-url="http://218.255.155.125:47097/Home/facebookResp?id=10613&type=moivecommunity" data-color="default" data-size="small" data-count="true" data-ver="3" style="display: none;"></div> -->
    <M2Vue v-if="isShowM2"></M2Vue>
    <div class="noteDiv">
      <el-dialog :title="noteInfo.title" :visible.sync="noteInfo.dialogVisible" width="600px" :show-close="false">
        <div class="ql-editor" v-html="noteHtml"></div>
        <div slot="title">
          <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            ">
            <div>
              {{ noteInfo.title }}
            </div>
            <div>
              <el-button type="text" size="small" @click="noShowNote"
                style="margin-bottom: 0px; margin-right: 10px; color: gray">不再顯示</el-button>
              <i class="el-icon-close" @click="noteInfo.dialogVisible = false"></i>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<style>
@import "../assets/css/desktop/normalize.css";
@import "../assets/css/font-awesome/all.min.css";
@import "../assets/css/desktop/main.css";
@import "../assets/css/mobile/m-main.css";
</style>

<script>
import headerTitle from "./common/Header";
import foot from "./common/Footer";
import social from "./common/SocialButton";
import M2Vue from "./Ad/M2.vue";
import moment from "moment";

// import "../assets/css/mobile/m-main.js";
export default {
  data () {
    return {
      noteInfo: {
        id: null,
        dialogVisible: false,
        title: "",
      },
      loginstatus: "",
      show: "",
      noteHtml: "",
      NoM2Page: [
        "albumviewPhotostream",
        "albumIndex",
        "feed",
        "uploadImage",
        "customerInfo",
        "SocialVideoUpload",
        "feedGroup_FeedGroupDetail",
      ],
    };
  },
  methods: {
    noShowNote () {
      let noShowNoteIdList = [];
      if (sessionStorage.getItem("noShowNote")) {
        noShowNoteIdList = JSON.parse(sessionStorage.getItem("noShowNote"));
      }
      noShowNoteIdList.push(
        this.$route.meta.notificationInfo.sgL_Type +
        this.noteInfo.id +
        this.noteInfo.sgL_UpdateTime
      );
      sessionStorage.setItem("noShowNote", JSON.stringify(noShowNoteIdList));
      this.noteInfo.dialogVisible = false;
    },
    noteCheck () {
      if (
        this.$route.meta.notificationInfo &&
        this.$route.meta.notificationInfo.sgL_Type
      ) {
        this.$api.BannerApi.SystemNoticeGetAll({
          SGL_Type: this.$route.meta.notificationInfo.sgL_Type,
          SkipCount: 0,
          MaxResultCount: 999,
        })
          .then((res) => {
            if (res.data.success) {
              const list = res.data.result.items;
              if (list && list.length) {
                let showInfo = undefined;
                let showList = list.filter(
                  (c) =>
                    c.sgL_TypeF.indexOf(
                      this.$route.meta.notificationInfo.sgL_Type
                    ) != -1 &&
                    c.sgL_Status !== "StopPublish" &&
                    moment().format("YYYY-MM-DD") >=
                    moment(c.sgL_StartTimeF).format("YYYY-MM-DD") &&
                    moment().format("YYYY-MM-DD") <=
                    moment(c.sgL_EndTimeF).format("YYYY-MM-DD")
                );
                if (showList.length) {
                  showList = showList.sort((a, b) => {
                    return b.id - a.id;
                  });
                  if (showList.length) {
                    showInfo = showList.find(
                      (c) => c.sgL_Status === "UrgentPublication"
                    );
                    if (!showInfo) {
                      showInfo = showList.find(
                        (c) => c.sgL_Status === "Inpublish"
                      );
                    }
                    if (showInfo) {
                      let aaa = false;
                      if (sessionStorage.getItem("noShowNote")) {
                        const test = JSON.parse(
                          sessionStorage.getItem("noShowNote")
                        );
                        if (
                          test.indexOf(
                            this.$route.meta.notificationInfo.sgL_Type +
                            showInfo.id +
                            showInfo.sgL_UpdateTime
                          ) === -1
                        ) {
                          aaa = true;
                        }
                      } else {
                        aaa = true;
                      }
                      if (aaa) {
                        this.noteInfo.id = showInfo.id;
                        this.noteInfo.title = showInfo.sgL_Title;
                        this.noteHtml = showInfo.sgL_Content;
                        this.noteInfo.dialogVisible = true;
                        this.noteInfo.sgL_UpdateTime = showInfo.sgL_UpdateTime;
                      }
                    }
                  }
                }
              }
            }
          })
          .catch((err) => { });
      }
    },
  },
  components: {
    headerTitle: headerTitle,
    foot: foot,
    Social: social,
    M2Vue,
  },
  mounted () {
    this.noteCheck();
    var obj = document.getElementById('backtop-btn');
    var scrollTop = null;

    // 置顶对象点击事件
    obj.onclick = function () {
      var timer = setInterval(function () {
        window.scrollBy(0, -100);
        if (scrollTop == 0)
          clearInterval(timer);
      }, 2);
    }

    // 窗口滚动检测
    window.onscroll = function () {
      scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      obj.style.display = (scrollTop >= 300) ? "block" : "none";
    }
  },
  watch: {
    $route: {
      handler: function (newvalue) {
        this.noteCheck();
      },
    },
  },
  computed: {
    isShowM2 () {
      if (this.NoM2Page.indexOf(this.$route.name) !== -1) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  .noteDiv>>>.el-dialog {
    width: 90% !important;
  }
}

.el-icon-close:hover {
  cursor: pointer;
}

.noteDiv>>>.el-dialog__body {
  padding: 0;
}

.noteDiv>>>.el-dialog__header {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue